import { render, staticRenderFns } from "./CreaSoggetto.vue?vue&type=template&id=960d91de&scoped=true&"
import script from "./CreaSoggetto.vue?vue&type=script&lang=js&"
export * from "./CreaSoggetto.vue?vue&type=script&lang=js&"
import style0 from "./CreaSoggetto.vue?vue&type=style&index=0&id=960d91de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960d91de",
  null
  
)

export default component.exports